import useTranslator from "@pma/hooks/use-translator"
import { Info } from "lucide-react"
import { Tooltip, TooltipContent, TooltipTrigger } from "@components/common/tooltip"

const GLOSSARY: Record<string, { he: string; en: string }> = {
  "boq": { he: "כתב כמויות — מסמך שמפרט את כל סוגי העבודות, הכמויות והמחירים בפרויקט", en: "Bill of Quantities — document listing all work types, quantities and prices" },
  "retention": { he: "עכבון — אחוז שמנוכה מכל חשבון ומשוחרר בסיום הפרויקט כביטחון", en: "Retention — percentage deducted from each bill as security, released at project completion" },
  "accumulated": { he: "מצטבר — הסכום הכולל שהצטבר מכל החשבונות הקודמים עד היום", en: "Accumulated — total sum from all previous bills to date" },
  "estimate": { he: "אומדן — הערכה ראשונית של עלויות לפני תחילת העבודה", en: "Estimate — initial cost assessment before work begins" },
  "discount": { he: "הנחה — הפחתה באחוזים ממחיר היחידה המקורי", en: "Discount — percentage reduction from original unit price" },
  "vat": { he: "מע\"מ — מס ערך מוסף, 18% בישראל", en: "VAT — Value Added Tax, 18% in Israel" },
  "signed": { he: "חתום — חשבון שנחתם על ידי מנהל הכספים ומוכן לתשלום", en: "Signed — bill signed by financial manager, ready for payment" },
  "approved": { he: "מאושר — חשבון שאושר על ידי המפקח ומחכה לחתימה", en: "Approved — bill approved by supervisor, awaiting signature" },
  "remaining": { he: "סכום שנותר — ההפרש בין סכום כתב הכמויות לבין סך החשבונות שאושרו ונחתמו", en: "Remaining amount — difference between BOQ sum and total approved/signed bills" },
}

export function FinancialTooltip({ term, children }: { term: string; children: React.ReactNode }) {
  const { locale } = useTranslator()
  const entry = GLOSSARY[term.toLowerCase()]
  if (!entry) return <>{children}</>
  const text = locale === "he" ? entry.he : entry.en

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex items-center gap-1 cursor-help">
          {children}
          <Info className="inline h-3.5 w-3.5 text-blue-400 hover:text-blue-600 transition-colors shrink-0" />
        </span>
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-64 leading-relaxed bg-black">
        {text}
      </TooltipContent>
    </Tooltip>
  )
}

export { GLOSSARY }
